import React from 'react'
import { connect } from 'react-redux'
import {
    getDeletedJobs,
    restoreDeletedJob
} from '../../redux/actions'

import {
    preparePager,
    prepareSearch
} from '../../common/tabletools'

import RestoreJobs from '../../components/restorejobs'

class RestoreJobsPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            pager: {
                defaultColumns: ['recoveryname', 'customer_name'],
                manual: true,
                pageno: 1,
                pagesize: 5,
                order: {
                    field: "recoveryname",
                    sorttype: 'asc'
                },
                search: [],
                global: false
            }
        }
    }

    render() {
        const {
            translate,
            jobs,
            restoreDeletedJob,
            getDeletedJobs
        } = this.props

        const {
            pager
        } = this.state
        if (jobs) {
            return (<RestoreJobs
                translate={translate}
                jobs={jobs}
                pager={pager}
                fetch={this.fetch}
                search={this.search}
                refresh={this.refresh}
                restoreDeletedJob={restoreDeletedJob}
                getDeletedJobs={getDeletedJobs}
            />)
        } else {
            return null
        }
    }

    fetch = (table, pager) => {
        this.props.getDeletedJobs(preparePager(table, pager))
    }

    refresh = () => {
        this.props.getDeletedJobs(this.state.pager)
    }

    componentWillMount() {
        this.props.getDeletedJobs(this.state.pager)
    }

    search = (term) => {
        const { jobs } = this.props
        const { columns } = jobs
        const { pager } = this.state

        const _pager = prepareSearch(term, columns, pager)
        _pager.global = term === '' ? false : true
        this.setState({
            pager: _pager
        })
        this.props.getDeletedJobs(_pager)
    }
}

const mapDispatchToProps = (dispatch, props) => ({
    getDeletedJobs: (pager) => {
        dispatch(getDeletedJobs(pager.search, pager.pageno, pager.pagesize, pager.order))
    },
    restoreDeletedJob: (jobId, pager) => {
        return dispatch(restoreDeletedJob(jobId, pager))
    }
})

const mapStateToProps = (state) => ({
    jobs: state.jobReducer.deletedJobs
})

export default connect(mapStateToProps, mapDispatchToProps)(RestoreJobsPage)